import { Card, Grid, Typography } from "@mui/material";
import moment from "moment";
import DataInterface from "../../../../interfaces/statistics/AdminStatisticsType";
import { DATE_FORMAT_STYLE_3 } from "../../../../utils/Utils";
import QuestionnaireStatistics from "./QuestionnaireStatistics";
import StatisticsAdminService, { StatisticsAdminServiceExport } from "./StatisticsAdminService";

const TypographyColumnTitle = ({ content }: any) => <Typography fontSize={12}>{content}</Typography>;
const TypographyColumnData = ({ content }: any) => <Typography fontSize={12} >{content}</Typography>;
const TypographyColumnDataNoWrap = ({ content }: any) => <Typography fontSize={12} noWrap sx={{
  width: '100%',
  textAlign: 'left',
}}>
  {content}
</Typography>;

export default function StatisticsAdmin() {
  const { data, feedbackStatistics }: StatisticsAdminServiceExport = StatisticsAdminService();
  const baseClass = "statistics-admin";

  return (
    <div className={`${baseClass}`}>
      <div className={`${baseClass}__subtext`}>{"Statistics admin"}</div>
      {feedbackStatistics && <QuestionnaireStatistics statistics={feedbackStatistics} />}
      <Grid container justifyContent="flex-start" alignItems="flex-start" rowSpacing={1} columnSpacing={1} height="630px" overflow={"auto"}>
        {data.map((di: DataInterface) => (
          <Grid container item xs={12} key={di.lecture.id}>
            <Card className={`${baseClass}__card`}>
              <Grid container item xs={12} flexDirection="row">
                <Grid container item xs={12} flexDirection="column" borderBottom={"1px solid white"} borderRight={"1px solid white"} alignItems={"center"}>
                  <TypographyColumnTitle content="Lecture info" />
                </Grid>
                <Grid container item xs={4} flexDirection="row" p={1}>
                  <Grid container item xs={7} flexDirection="column" alignItems={"flex-start"}>
                    <TypographyColumnTitle content="Email" />
                    <TypographyColumnTitle content="University" />
                    <TypographyColumnTitle content="Pseudonyms created" />
                    <TypographyColumnTitle content="New accounts" />
                    <TypographyColumnTitle content="Start time" />
                    <TypographyColumnTitle content="Questions during lecture" />
                    <TypographyColumnTitle content="Discussions during lecture" />
                    <TypographyColumnTitle content="Questions after class" />
                    <TypographyColumnTitle content="Discussions after class" />
                  </Grid>
                  <Grid container item xs={5} flexDirection="column" alignItems={"flex-start"}>
                    <TypographyColumnDataNoWrap content={di.creator.email} />
                    <TypographyColumnDataNoWrap content={di.creator.university} />
                    <TypographyColumnData content={di.pseudonymCreated} />
                    <TypographyColumnData content={di.newUsers} />
                    <TypographyColumnData content={moment(di.lecture.startTime).format(DATE_FORMAT_STYLE_3)} />
                    <TypographyColumnData content={di.lecture.allowQuestionsDuringLecture == true ? "Yes" : "No"} />
                    <TypographyColumnData content={di.lecture.allowDiscussionsDuringLecture == true ? "Yes" : "No"} />
                    <TypographyColumnData content={di.lecture.allowQuestionsAfterClass == true ? "Yes" : "No"} />
                    <TypographyColumnData content={di.lecture.allowDiscussionsAfterClass == true ? "Yes" : "No"} />
                  </Grid>
                </Grid>
                <Grid container item xs={4} flexDirection="row" p={1}>
                  <Grid container item xs={10} flexDirection="column" alignItems={"flex-start"}>
                    <TypographyColumnTitle content="Questions posted (during/after)" textTransform="justified" />
                    <TypographyColumnTitle content="Questions liked by students" />
                    <TypographyColumnTitle content="Questions liked by teacher" />
                    <TypographyColumnTitle content="Students never posted question" />
                    <TypographyColumnTitle content="Answers posted" />
                    <TypographyColumnTitle content="Answers liked by students" />
                    <TypographyColumnTitle content="Answers liked by teacher" />
                    <TypographyColumnTitle content="Students never posted answer" />
                    <TypographyColumnTitle content="Discussions" />
                  </Grid>
                  <Grid container item xs={2} flexDirection="column" alignItems={"flex-start"}>
                    <TypographyColumnData content={di.questionsDuringLecture + ' / ' + di.questionsAfterLecture} />
                    <TypographyColumnData content={di.questionsLikedByStudentsDuringLecture + ' / ' + di.questionsLikedByStudentsAfterLecture} />
                    <TypographyColumnData content={di.questionsLikedByTeacherDuringLecture + ' / ' + di.questionsLikedByTeacherAfterLecture} />
                    <TypographyColumnData content={di.questionsStudentNeverPostedDuringLecture + ' / ' + di.questionsStudentNeverPostedAfterLecture} />
                    <TypographyColumnData content={di.answersDuringLecture + ' / ' + di.answersAfterLecture} />
                    <TypographyColumnData content={di.answersLikedByStudentsDuringLecture + ' / ' + di.answersLikedByStudentsAfterLecture} />
                    <TypographyColumnData content={di.answersLikedByTeacherDuringLecture + ' / ' + di.answersLikedByTeacherAfterLecture} />
                    <TypographyColumnData content={di.studentsNeverAnsweredDuringLecture + ' / ' + di.studentsNeverAnsweredAfterLecture} />
                    <TypographyColumnData content={di.discussionsDuringLecture + ' / ' + di.discussionsAfterLecture} />
                  </Grid>
                </Grid>
                <Grid container item xs={4} flexDirection="row" p={1}>
                  <Grid container item xs={10} flexDirection="column" alignItems={"flex-start"}>
                    <TypographyColumnTitle content="Lost" />
                    <TypographyColumnTitle content="Not Clear" />
                    <TypographyColumnTitle content="Great" />
                    <TypographyColumnTitle content="Too Hard" />
                    <TypographyColumnTitle content="Too Simple" />
                    <TypographyColumnTitle content="Total Feedback" />
                    <TypographyColumnTitle content="Students posted feedback" />
                    <TypographyColumnTitle content="Students never posted feedback" />
                    <TypographyColumnTitle content="Uploaded a presentation?" />
                  </Grid>
                  <Grid container item xs={2} flexDirection="column" alignItems={"flex-start"}>
                    <TypographyColumnData content={di.expressions.lost} />
                    <TypographyColumnData content={di.expressions.notClear} />
                    <TypographyColumnData content={di.expressions.great} />
                    <TypographyColumnData content={di.expressions.tooHard} />
                    <TypographyColumnData content={di.expressions.tooSimple} />
                    <TypographyColumnData content={di.expressions.total} />
                    <TypographyColumnData content={di.expressions.postedFeedback} />
                    <TypographyColumnData content={di.expressions.neverPostedFeedback} />
                    <TypographyColumnData content={di.uploadedPresentation == true ? "Yes" : "No"} />
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
